import './viewplans.css';
import React, { useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DownsideBackground from '../../firstpage/DownsideBackground';
import PlansComparison from '../../PricingPlans/PlansComparison';
import ContiBenefits from "../../PricingPlans/ContiBenefits";

import {
  faCheck,
  faXmark,
  faGraduationCap,
  faGamepad,
  faChartLine,
  faCertificate,
  faClock,
  faHeadset,
  faCheckCircle
} from '@fortawesome/free-solid-svg-icons';

import { useNavigate } from "react-router-dom";


const Viewplans = () => {

  const [open, setOpen] = useState(null);
  const navigate = useNavigate();


  return (

    <div className="plans-page-professional">




<PlansComparison />



    <ContiBenefits />



   



      {/* =========================
          FAQ
      ========================== */}

      <div className="faq-section-professional">

        <h2 className="section-title-professional">
          Intrebari frecvente
        </h2>


        <div className="faq-container-professional">


          <div
            className="faq-item-professional"
            onClick={() => setOpen(open === 1 ? null : 1)}
          >

            <div className="faq-question-professional">

              <span>
                Ce include abonamentul Premium?
              </span>

              <span className="faq-icon-professional">
                {open === 1 ? "−" : "+"}
              </span>

            </div>


            {open === 1 && (

              <div className="faq-answer-professional">

                Abonamentul Premium ofera acces la toate cursurile
                ContaLearn, vieti nelimitate, acces direct la module
                si functionalitatile Premium disponibile in platforma.

              </div>

            )}

          </div>



          <div
            className="faq-item-professional"
            onClick={() => setOpen(open === 2 ? null : 2)}
          >

            <div className="faq-question-professional">

              <span>
                Pot anula abonamentul lunar?
              </span>

              <span className="faq-icon-professional">
                {open === 2 ? "−" : "+"}
              </span>

            </div>


            {open === 2 && (

              <div className="faq-answer-professional">

                Da. Abonamentul lunar poate fi anulat, iar accesul
                Premium ramane disponibil pana la finalul perioadei
                deja platite.

              </div>

            )}

          </div>



          <div
            className="faq-item-professional"
            onClick={() => setOpen(open === 3 ? null : 3)}
          >

            <div className="faq-question-professional">

              <span>
                Care este diferenta dintre Lunar si Anual?
              </span>

              <span className="faq-icon-professional">
                {open === 3 ? "−" : "+"}
              </span>

            </div>


            {open === 3 && (

              <div className="faq-answer-professional">

                Ambele planuri ofera aceleasi beneficii Premium.
                Planul Lunar costa 39,99 LEI/luna, iar planul Anual
                costa 359 LEI pentru 12 luni, echivalentul a
                aproximativ 29,92 LEI/luna.

              </div>

            )}

          </div>



          <div
            className="faq-item-professional"
            onClick={() => setOpen(open === 4 ? null : 4)}
          >

            <div className="faq-question-professional">

              <span>
                Este ContaLearn potrivit pentru incepatori?
              </span>

              <span className="faq-icon-professional">
                {open === 4 ? "−" : "+"}
              </span>

            </div>


            {open === 4 && (

              <div className="faq-answer-professional">

                Da. Continutul este structurat astfel incat sa poti
                incepe cu notiunile fundamentale si sa avansezi
                treptat.

              </div>

            )}

          </div>



          <div
            className="faq-item-professional"
            onClick={() => setOpen(open === 5 ? null : 5)}
          >

            <div className="faq-question-professional">

              <span>
                Primesc certificat la final?
              </span>

              <span className="faq-icon-professional">
                {open === 5 ? "−" : "+"}
              </span>

            </div>


            {open === 5 && (

              <div className="faq-answer-professional">

                Pentru cursurile eligibile finalizate poti primi
                un certificat de finalizare ContaLearn, inclusiv
                daca folosesti planul Gratuit.

              </div>

            )}

          </div>



          <div
            className="faq-item-professional"
            onClick={() => setOpen(open === 6 ? null : 6)}
          >

            <div className="faq-question-professional">

              <span>
                Pot folosi ContaLearn de pe telefon?
              </span>

              <span className="faq-icon-professional">
                {open === 6 ? "−" : "+"}
              </span>

            </div>


            {open === 6 && (

              <div className="faq-answer-professional">

                ContaLearn poate fi accesat din browser de pe
                dispozitive compatibile, inclusiv telefon,
                tableta si calculator.

              </div>

            )}

          </div>


        </div>

      </div>




<DownsideBackground />

    </div>

  );

};


export default Viewplans;